<template>
    <div>
        <div class="CreatAccount">
            <!-- 主体 -->
            <div class="container">        
                <div style="padding: 25px; background: #fff;">
                    <div style=" display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 10px;
                        color: rgba(53, 53, 53, 1);"><h2>{{userCode ? $t('message.a2ddla') : $t('message.addSubAccount')}}</h2>
                    </div>
                    <div style="padding: 25px 0; border-bottom: 1px solid #cdcdcd;">
                        <div style="display: flex; align-items: center;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;"><span style="color: red;">*</span>{{$t('message.accountInfoModifyUserName')}}</span>
                            <el-input v-model.trim="userObj.userName" 
                                      class="input" 
                                      :disabled="userCode ? true : false"
                                      style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        <div style="display: flex; align-items: center; margin: 5px 0;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1);"></span>
                            <span style="margin-left: 12px; color: #aaa;">{{$t('message.a1wspa')}}</span>                          
                        </div>
                        <div style="display: flex; align-items: center;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">{{$t('message.nickname')}}</span>
                            <el-input v-model.trim="userObj.nickName" 
                                      class="input" 
                                      style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        <div style="display: flex; align-items: center; margin: 5px 0;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1);"></span>
                            <span style="margin-left: 12px; color: #aaa;">{{$t('message.c6qdsa')}}</span>                          
                        </div>
                        <template v-if="!userCode">
                            <div style="display: flex; align-items: center;">
                                <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;"><span style="color: red;">*</span>{{$t('message.passwordText')}}</span>
                                <el-input   v-model.trim="userObj.password"
                                            type="password" 
                                            class="input" 
                                            style="width: 500px; height: 35px; margin-left: 10px;"/>
                            </div>
                            <div style="display: flex; align-items: center; margin: 5px 0;">
                                <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1);"></span>
                                <span style="margin-left: 12px; color: #aaa;">{{$t('message.c5qhd')}}</span>                          
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;"><span style="color: red;">*</span>{{$t('message.confirmPassword2')}}</span>
                                <el-input   v-model.trim="iSpassword" 
                                            type="password" 
                                            class="input" 
                                            style="width: 500px; height: 35px; margin-left: 10px;"/>
                            </div>
                        </template>
                       
                    </div>             
                    <template>
                        
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="margin-left: 100px; color: red;">*</span><span style="margin-right: 10px;" class="tit">{{$t('message.c6qdsdk')}}</span>
                            <el-checkbox :value="mainAccountPay" 
                                         label="1" 
                                         @change="(e) => {change(e,'1')}">{{$t('message.yes')}}</el-checkbox>
                            <el-checkbox :value="mainAccountPay" 
                                         label="0" 
                                         @change="(e) => {change(e,'0')}">{{$t('message.no')}}</el-checkbox>
                        </div>
                        <div v-if="mainAccountPay[0] === '1'" style="position: relative; padding: 20px; margin-top: 20px; box-shadow: 1px 2px 4px 2px rgba(224, 224, 224, 0.5);">
                        
                            <div style=" display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin-bottom: 10px;
                                color: rgba(53, 53, 53, 1);"><h3>{{$t('message.submitBilling')}}<span style="font-size: 12px; color: red;">{{$t('message.startMustWrite')}}</span></h3>
                            </div>                  
                            <div style="position: relative; padding: 20px; margin-top: 20px; box-shadow: 1px 2px 4px 2px rgba(224, 224, 224, 0.5);">
                                <el-checkbox-group :value="invoiceType" >
                                    <el-checkbox label="2" 
                                                 style="color: #0aa7ee;"
                                                 @change="selectinvoiceType('2')">{{$t('message.iTelegraphicTicket')}}</el-checkbox>
                                    <el-checkbox label="3" 
                                                 :style="{marginLeft: !$isZh() ? '80px' : '180px',color: '#0AA7EE'}"
                                                 @change="selectinvoiceType('3')">{{$t('message.ispecialTicket')}}
                                        <div style="position: absolute;color: #9b9b9b;width: 314px;white-space: break-spaces;font-size: 14px">根据最新的政府政策调整，自即日起，我司将全面实行电子发票（电票）开具，不再提供纸质发票。</div>
                                    </el-checkbox>
                                    <!--<el-checkbox label="0" -->
                                    <!--             :style="{marginLeft: !$isZh() ? '130px' : '180px',color: '#0AA7EE'}"-->
                                    <!--             @change="selectinvoiceType('0')">DEBIT NOTE</el-checkbox>-->
                                </el-checkbox-group> 
                                <div style="margin-top: 20px; line-height: 1.5; color: #aaa;">
                                    <p>{{$t('message.aboutElectronicInvoiceTit')}}</p>
                                    <p>{{$t('message.aboutElectronicInvoice1')}}</p>
                                    <p>{{$t('message.aboutElectronicInvoice2')}}</p>
                                    <p>{{$t('message.aboutElectronicInvoice3')}}</p>
                                </div>
                                

                            </div>
                            <template v-if="invoiceType[0] === '2' || invoiceType[0] === '3'">
                                <div v-if="invoiceType[0] === '2' && isMonthly === '1'" class="info-item">
                                    <span class="tit" style="width: 70px;">{{$t('message.billingStatus')}}</span>
                                    <el-checkbox v-model="invoiceMerge"
                                                 label="1"                                          
                                                 style="color: #0aa7ee;">{{$t('message.mergeInvoice')}}</el-checkbox>
                                </div>
                                <div class="info-item">
                                    <span class="tit" style="margin-right: 15px;">{{$t('message.invoiceName')}}</span>
                                    <el-select v-model="invoiceInfo"
                                               class="input">
                                            
                                        <el-option v-for="(item,i) in titlevalue"
                                                   :key="i"
                                                   :label="item.title"
                                                   :value="item">                          
                                        </el-option>
                                    </el-select>
                                    <template v-if="['2','3'].includes(invoiceType[0])">
                                        <span class="tit" style="margin-left: 80px;"><span class="tcolor">*</span>{{$t('message.financialMailbox')}}</span>
                                        <el-input v-model.trim="invoiceInfo.financialMailbox" 
                                                  class="input" 
                                                  style="margin-left: 16px;"/>
                                        <span style="margin-left: 16px; font-size: 10px; color: #aaa;">{{$t('message.emailCanModified')}}</span>
                                    </template>
                                    
                                    
                                </div>
                                <hr style="border-top: 0.5px dashed #aaa;"/>
                                <div class="info-item" style="justify-content: space-between;">
                                    
                                    <div>
                                        <span class="tit"><span class="tcolor">*</span>{{$t('message.invoiceName')}}</span>
                                        <el-input v-model.trim="invoiceInfo.title" 
                                                  class="input" 
                                                  style="width: 270px; margin-left: 16px;"/>
                                    </div>
                                    <div>
                                        <span class="tit" style="margin-left: 50px;"><span class="tcolor">*</span>{{$t('message.openBank')}}</span>
                                        <el-input v-model.trim="invoiceInfo.bankName"
                                                  class="input" 
                                                  style="width: 270px; margin-left: 16px;"/>
                                    </div> 
                                            
                                </div>
                                <div class="info-item" style="justify-content: space-between;">
                                    <div style="white-space: nowrap">
                                        <span class="tit"><span class="tcolor">*</span>{{$t('message.bankAccount')}}</span>
                                        <el-input v-model.trim="invoiceInfo.bankAccount" 
                                                  class="input"
                                                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(-15px)'}"/>
                                    </div>
                                    <div style="white-space: nowrap">
                                        <span class="tit" style="margin-left: 50px;"><span class="tcolor">*</span>{{$t('message.increaseTicketAddress')}}</span>
                                        <el-input v-model.trim="invoiceInfo.increaseTicketAddressPhone" 
                                                  class="input" 
                                                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(35px)'}"/>  
                                    </div>
                                    <div style="white-space: nowrap">
                                        <span class="tit" style="margin-left: 50px;"><span class="tcolor">*</span>{{$t('message.taxpayerIdNumber')}}</span>
                                        <el-input v-model.trim="invoiceInfo.taxId" 
                                                  class="input" 
                                                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(35px)'}"/>
                                    </div>       
                                </div>
                            </template>
                            
                            <!--<div v-if="invoiceType[0] === '3'"-->
                            <!--     class="info-item"-->
                            <!--     style="justify-content: space-between;">-->
                            <!--    <div>-->
                            <!--        <span class="tit"><span class="tcolor"></span>{{$t('message.shippingContactInformation')}}</span>-->
                            <!--        <el-input v-model.trim="invoiceInfo.expressContactInfo"-->
                            <!--                  class="input"-->
                            <!--                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(-15px)'}"/>-->
                            <!--    </div>-->
                            <!--    <div>-->
                            <!--        <span class="tit" style="margin-left: 50px;"><span class="tcolor"></span>{{$t('message.shippingCall')}}</span>-->
                            <!--        <el-input v-model.trim="invoiceInfo.expressPhone"-->
                            <!--                  class="input"-->
                            <!--                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(35px)'}"/>-->
                            <!--    </div>-->
                            <!--    <div>-->
                            <!--        <span class="tit" style="margin-left: 50px;"><span class="tcolor"></span>{{$t('message.shippingContact')}}</span>-->
                            <!--        <el-input v-model.trim="invoiceInfo.expressContact"-->
                            <!--                  class="input"-->
                            <!--                  :style="{marginLeft: '16px',transform: $isZh() ? 'none' : 'translateX(35px)'}"/>-->
                            <!--    </div>-->
                            <!--</div>-->
                        </div>
                        
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="margin-left: 25px; color: red;">*</span><span class="tit">{{$t('message.ichargingStandard')}}</span>
                            <el-input v-model="feeTemplateObj.feeTemplateName"                              
                                      style="width: 400px; height: 35px; margin-left: 10px;"
                                      @click.native="getImportUserFeeTemplateListData()">
                                <template slot="append">{{$t('message.b5sdbzda')}}</template>
                            </el-input>
                        </div>
                    </template>
                    <div style="padding-left: 25px; margin-top: 20px; font-size: 16px; color: rgba(24, 24, 24, 1);">
                        <span>{{$t('message.c4dfk')}} </span>  
                        <i v-if="!isopen"
                           class="el-icon-arrow-down" 
                           style="cursor: pointer;"
                           @click="isopen = true"></i><i    v-if="isopen" 
                                                            class="el-icon-arrow-up"
                                                            style="cursor: pointer;"
                                                            @click="isopen = false"></i></div>
                    <div :style="{margin: '25px 0',overflow: 'hidden',height,transition: 'height .3s'}">
                        <div style="display: flex; align-items: center;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">{{$t('message.accountInfoModifyUserMobile')}}</span>
                            <el-select
                                    v-model="userObj.SMSCode"
                                    class="input" 
                                    style="width: 92px; height: 35px; margin-left: 10px;">
                                <el-option
                                        v-for="item in SMS"
                                        :key="item.value"
                                        :label="`+${item.countryCode}`"
                                        :value="item.countryCode">
                                    <span style="float: left;">{{`${item.countryNameC}${item.codeAbbr}(+${item.countryCode})`}}</span>
                                </el-option>
                            </el-select>
                            <el-input   v-model.trim="userObj.mobile" 
                                        class="input" 
                                        style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">{{$t('message.weChat')}}</span>
                            <el-input   v-model.trim="userObj.weChat" 
                                        class="input" 
                                        style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">{{$t('message.accountInfoModifyUserEmail')}}</span>
                            <el-input v-model.trim="userObj.email" 
                                      class="input" 
                                      style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">QQ</span>
                            <el-input v-model.trim="userObj.qq" 
                                      class="input" 
                                      style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 20px;">
                            <span style="width: 90px; font-size: 16px; color: rgba(24, 24, 24, 1); text-align: right;">{{$t('message.accountInfoModifyUserPhone')}}</span>
                            <el-input v-model.trim="userObj.phone" 
                                      class="input" 
                                      style="width: 500px; height: 35px; margin-left: 10px;"/>
                        </div>
                    </div>
                    
                    <div style="display: flex; justify-content: flex-end; margin-top: 28px;">                       
                        <el-button type="primary" 
                                   style="font-size: 16px;"
                                   :loading="loading"
                                   @click="getCode()">{{$t('message.submit')}}</el-button>
                    </div>  
                </div>
               
                <el-dialog title=""
                           :visible.sync="templateDailog"
                           :close-on-click-modal="false"
                           width="1240px">
                    
                    <div class="contentBox1">
                        <div class="selectBox">
                            <span class="text">{{$t('message.ielectingTemplate')}}</span>
                            <el-select v-model="nowFeeTemplateId" class="input">
                                <el-option v-for="(item, index) in feeTemplateList"
                                           :key="index"
                                           :label="item.feeTemplateName"
                                           :value="item.feeTemplateId">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="topName">
                            <p class="title">{{costTemplate.feeTemplateName}}</p>
                            <div>
                                <p class="titleTwo">{{displayTemplate[0] ? displayTemplate[0].feeTemplateName : ''}}</p>
                            </div>
                        </div>
                        <div class="separate">
                           
                            <CostTemplate v-if="costTemplate" :costTemplate="costTemplate"></CostTemplate>
                            <!-- 合同模板 -->
                            <div class="displayTemplate">
                                <div v-for="(item,index) in displayTemplate[0] ? displayTemplate[0].feeDetailList : []"
                                     :key="index">
                                    <div class="capacityOne">
                                        <div class="tbody">
                                            <p>{{item.feeName}}</p>
                                            <p style="margin-left: 14px;">{{$currencyUnit($getCookie('currency'))}}/{{item.unit === '票' ? $t('message.Itickets') : $t('message.kilogram')}}</p>
                                        </div>
                                        <div class="price" :class="{priceEn: !$isZh()}">
                                            <!-- 单价 -->
                                            <div style="width: 130px;">
                                                <span>{{$t('message.unitPrice')}}</span>
                                                <span class="unitPriceInput">¥{{item.unitPrice}}</span>
                                            </div>
                                            <!-- 最低费用 -->
                                            <div v-if="item.unit !== '票'" style="flex: 1;">           
                                                <div v-if="item.minimumAmount" :style="{display: 'inline-block',width:!$isZh() ? '245px' : '165px'}">   
                                                    <span>{{$t('message.iminimumcharge')}}</span>
                                                    <span class="unitPriceInput" style="margin-left: 0;">{{item.minimumAmount}}</span>
                                                    <span style="">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span>
                                                </div>
                                                <div v-if="item.maximumAmount" :style="{display: 'inline-block',width:!$isZh() ? '245px' : '170px'}">
                                                    <span >{{$t('message.maximumcharge')}}</span>
                                                    <span class="unitPriceInput" style="margin-left: 0;">{{item.maximumAmount}}</span>
                                                    <span style="">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span> 
                                                </div>                                 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="capacityTwo">
                                    <p class="rightFeeName">{{$t('message.istoragefee')}}</p>
                                    <!-- 仓储费用明细列表 -->
                                    <div v-for="item in displayTemplate[0] ? displayTemplate[0].cargofeeList : []"
                                         :key="item.cargoType">
                                        <div class="content">
                                            <div class="price" :class="{priceEn: !$isZh()}">
                                                <div :style="{width:!$isZh() ? '100%' : '193px'}">
                                                    <span :style="{width:  !$isZh() ? '200px' : '56px',display: 'inline-block'}">{{cargoTypeList[item.cargoType]}}</span>
                                                    <span class="unitPriceInput" style="margin-left: 10px;">{{item.unitPrice}}</span>
                                                    <span style="margin-left: 5px;">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.kilogram')}}/{{$t('message.day')}}</span>
                                                </div>
                                                <div :style="{marginTop: !$isZh() ? '18px' : '0',display:'flex',flex:'1'}">
                                                    <div v-if="item.minimumAmount" :style="{flex:!$isZh() ? 'unset' : '1',width:!$isZh() ? '255px' :'165px'}">
                                                        <span>{{$t('message.iminimumcharge')}}</span>
                                                        <span class="unitPriceInput" style="margin-left: 0;">{{item.minimumAmount}}</span>
                                                        <span>{{$currencyUnit($getCookie('currency'))}}/{{item.cargoType === '0' ? $t('message.Itickets') : $t('message.day')}}</span>
                                                    </div>
                                                    <div v-if="item.maximumAmount" style="flex: 1;">
                                                        <span >{{$t('message.maximumcharge')}}</span>
                                                        <span class="unitPriceInput" style="margin-left: 0;">{{item.maximumAmount}}</span>
                                                        <span style="">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="safekeeping">
                                                <template v-if="item.freeDays">
                                                    <span :style="{marginLeft: !$isZh() ? '-13px' : '52px'}">本地免费保管</span>
                                                    <div>
                                                        <span>{{item.freeDays}}</span>
                                                        <span style="">{{$t('message.day')}}</span>
                                                    </div>
                                                </template>
                                                <template v-if="item.otherCityfreeDays">
                                                    <span>/外地免费保管</span>
                                                    <div>
                                                        <span>{{item.otherCityfreeDays}}</span>
                                                        <span style="">{{$t('message.day')}}</span>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 危险品仓储费用明细列表 -->
                                    <div v-for="item in displayTemplate[0] ? displayTemplate[0].dangerCargofeeList : []"
                                         :key="item.cargoType + 'a'">
                                        <div class="danger">
                                            <div class="dangerContent" :style="{flexDirection:  !$isZh() ? 'column' : 'unset',alignItems: !$isZh() ? 'flex-start' : 'center'}">
                                                <p class="cargoType"  :style="{width: !$isZh() ? '200px' : '56px',paddingBottom: !$isZh() ? '0' : '88px',marginTop:  !$isZh() ? '18px' : '0px'}">{{cargoTypeList[item.cargoType]}}</p>
                                                <div class="price" :style="{paddingLeft: '0px',alignItems: !$isZh() ? 'flex-start' : 'center'}">
                                                    <div class="tbodyp">
                                                        <span class="unitPriceInput">{{item.level1.unitPrice}}</span>
                                                        <span style=" box-sizing: border-box; display: inline-block; text-align: left;">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.kilogram')}}/{{$t('message.day')}}</span>
                                                        <span></span>
                                                        <span>{{`（${item.level1.dayStart}-${item.level1.dayEnd}${$t('message.day')}）`}}</span>
                                                    </div>
                                                    <div class="tbodyp">
                                                        <span class="unitPriceInput">{{item.level2.unitPrice}}</span>
                                                        <span>{{$currencyUnit($getCookie('currency'))}}/{{$t('message.kilogram')}}/{{$t('message.day')}}</span>
                                                        <span style=" box-sizing: border-box; display: inline-block; text-align: left;"></span>
                                                        <span>{{`（${Number(item.level1.dayEnd) + 1}-${item.level2.dayEnd}${$t('message.day')}）`}}</span>
                                                    </div>
                                                    <div class="tbodyp">
                                                        <span class="unitPriceInput">{{item.level3.unitPrice}}</span>
                                                        <span>{{$currencyUnit($getCookie('currency'))}}/{{$t('message.kilogram')}}/{{$t('message.day')}}</span>
                                                        <span style=" box-sizing: border-box; display: inline-block; text-align: left;"></span>
                                                        <span>{{`（${Number(item.level2.dayEnd) + 1}${$t('message.idaysandabove')}）`}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div :style="{marginLeft: !$isZh() ? '23px' : '85px',marginTop:  !$isZh() ? '5px' : '0'}">
                                                <div v-if="item.minimumAmount" :style="{display: 'inline-block',width:!$isZh() ? '255px' : '180px'}">
                                                    <span>{{$t('message.iminimumcharge')}}</span>
                                                    <span class="unitPriceInput" style="margin-left: 0;">{{item.minimumAmount}}</span>
                                                    <span>{{$currencyUnit($getCookie('currency'))}}/{{item.cargoType === '0' ? $t('message.Itickets') : $t('message.day')}}</span>
                                                </div>
                                                <template v-if="item.maximumAmount">
                                                    <span >{{$t('message.maximumcharge')}}</span>
                                                    <span class="unitPriceInput" style="margin-left: 0;">{{item.maximumAmount}}</span>
                                                    <span style="">{{$currencyUnit($getCookie('currency'))}}/{{$t('message.Itickets')}}</span>
                                                </template>
                                            </div>
                                            <div :style="{marginLeft: !$isZh() ? '23px' : '85px',marginTop:'12px',display:'flex'}">
                                                <template v-if="item.freeDays">
                                                    <span>本地免费保管</span>
                                                    <div>
                                                        <span>{{item.freeDays}}</span>
                                                        <span style="">{{$t('message.day')}}</span>
                                                    </div>
                                                </template>
                                                <template v-if="item.otherCityfreeDays">
                                                    <span>/外地免费保管</span>
                                                    <div>
                                                        <span>{{item.otherCityfreeDays}}</span>
                                                        <span style="">{{$t('message.day')}}</span>
                                                    </div>
                                                </template>                                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="opeartingBtnBox">
                            <el-button type="primary"
                                       class="opeartingBtn"
                                       @click="choose()">{{$t('message.confirm')}}</el-button>
                        </div>
                        <SJMLoading v-if="pageLoading"></SJMLoading>
                    </div>                                             
                                      
                </el-dialog> 
                    
            </div>
            
            <SJMLoading v-if="CreatAccountLoading" z-inden="11"></SJMLoading>    
        </div>
      
    </div>
</template>
<script>
    import SMS from '@/assets/json/SMS.json';// 短信前缀列表
    import CostTemplate from '@/components/personalCenter/importBusiness/CostTemplate';
    export default {
        name: 'CreatAccount',// 进口主页
        components: {
            CostTemplate
        },
        data() {
            return {     
                isopen: this.$route.query.userCode ? true : false, 
                CreatAccountLoading: false,
                height: this.$route.query.userCode ? '266px' : '0px',  
                userCode: this.$route.query.userCode,
                nicknameRegular: this.$store.state.Regular.nickname,// 昵称正则
                mobileRegular: this.$store.state.Regular.mobile,// 手机号正则
                emailReg: this.$store.state.Regular.email,// 邮箱正则
                usernameRegular: this.$store.state.Regular.username,// 用户名正则
                passwordRegular: this.$store.state.Regular.password,// 密码正则
                SMS: SMS,
                userObj: {SMSCode: '86'},
                iSpassword: '',
                invoiceMerge: [], // 合并开票
                mainAccountPay: [], // 主账号
                titlevalue: [], // 开票抬头集合
                isMonthly: '', // 月结
                feeTemplateObj: '', // 费用模版Id
                invoiceType: [], // 开票类型 0-DEBIT NOTE、2-增值税普通发票（电票）、3-增值税专用发票（纸票）
                financialMailbox: '', // 财务邮箱          
                // 开票信息 若不开票 发送空对象
                invoiceInfo: {
                    title: '',// 开票抬头
                    taxId: '',// 纳税人识别号
                    bankName: '',// 开户银行
                    bankAccount: '',// 银行账号
                    increaseTicketAddressPhone: '',// 增票地址电话
                    expressContactInfo: '',// 寄票联系信息（备注）
                    expressPhone: '',// 寄票电话
                    expressContact: '',// 寄票联系人
                },

                loading: false, // 提交按钮loading
                templateDailog: false, // 模板弹框
                detialDailog: false, // 明细弹框

                feeTemplateList: [],// 模板列表
                nowFeeTemplateId: '',// 当前选中的模板id
                displayTemplate: [],// 合同模板
                pageLoading: false,// pageLoading
                cargoTypeList: {
                    0: this.$t('message.generalGoods'),
                    1: this.$t('message.dangerousGoods'),
                    2: this.$t('message.coldCollection'),
                    5: this.$t('message.b5sdbzdasda'),
                    8: this.$t('message.dangerousColdGoods')
                },
            };
        },
        computed: {
            costTemplate() {
                return this.feeTemplateList.filter(i => i.feeTemplateId === this.nowFeeTemplateId)[0] || '';
            },
           
           
        },
        watch: {
            isopen(n) {
                if (n) {
                    this.height = '266px';
                } else {
                    this.height = '0px';
                }
            }
        },
        created() {
            this.drawinvoice(); 
            // let msg = await getImportUserFeeTemplateListData().catch((data) => data);
            // if (msg) {
            //    this.$Message({msg})   
            // }
            if (this.userCode) {
                this.getdataObj();
            }
            
        },
        methods: {  
            getdataObj() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                    data: {
                        act: 'getModifyImportSubAccountData',// 获取修改进口新分账户的数据
                        userCode: this.userCode,// 用户CODE
                    },
                    beforeSend: () => {
                        this.CreatAccountLoading = true; 
                    },
                    success: (res) => {
                        this.feeTemplateObj = {feeTemplateId: res.success.feeTemplateId,feeTemplateName: res.success.feeTemplateName};
                        this.mainAccountPay = [res.success.mainAccountPay];
                        this.invoiceType = [res.success.invoiceType];
                        // this.financialMailbox = res.success.financialMailbox;
                        this.invoiceMerge = res.success.invoiceMerge === '1' ? [res.success.invoiceMerge] : ['0'];
                        let mobile = res.success.mobile;
                        let mobile0 = mobile ? mobile.split('-')[0] : '';
                        this.userObj = {userName: res.success.userName,
                                        nickName: res.success.nickName,
                                        // password: res.success.password,
                                        mobile: mobile ? mobile.split('-')[1] : '',
                                        weChat: res.success.weChat,
                                        email: res.success.email,
                                        qq: res.success.qq,
                                        phone: res.success.phone,
                                        SMSCode: mobile0 ? mobile0.split('+')[1] : '86'
                        }; 
                        this.invoiceInfo = {...res.success.invoiceInfo,value: res.success.invoiceInfo.title,financialMailbox: res.success.financialMailbox};              

                        
                    },
                    complete: () => {
                        this.CreatAccountLoading = false; 
                    }
                });
            },
            selectinvoiceType(e) {            
                this.invoiceType = [e]; 
            },
            choose() {
                this.templateDailog = false;
                this.feeTemplateObj = this.costTemplate ? JSON.parse(JSON.stringify(this.costTemplate)) : {};
            },
            
          
            getImportUserFeeTemplateListData() {
                new Promise((r,j) => {
                    this.templateDailog = true;
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportFeeTemplateHandler.ashx',
                        data: {
                            act: 'getImportUserFeeTemplateListData',// 获取进口用户费用模版列表的数据
                            type: '3',// 0-已完成、1-末完成、2-选择模版页渲染（已完成模版+合同模版）
                            orderBillCode: '',// 托单号（type为2的时候有值）
                        },
                        beforeSend: () => {
                            this.pageLoading = true; 
                        },
                        success: (res) => {
                            this.feeTemplateList = res.success.feeTemplateList;
                            this.feeTemplateList.forEach(i => {
                                if (i.contractTemplate === '1') {
                                    this.displayTemplate.push(i);
                                }
                            });

                            this.nowFeeTemplateId = this.feeTemplateList[0].feeTemplateId;
                            r();
                        },
                        error: () => {
                            j(this.$t('message.b1dsk1am')); 
                        },
                        complete: () => {
                            this.pageLoading = false; 
                        }
                    });
                }); 
                
            }, 
            change(e,type) {            
                this.mainAccountPay = [type];                     
            }, 
             
            drawinvoice() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAssignOrderHandler.ashx',
                    data: {
                        act: 'getImportInvoiceInfoData',// 获取 进口订单状态节点的数据                                      
                    },
                    beforeSend: () => {
                       
                    },
                    success: (res) => {
                        this.isMonthly = res.success.isMonthly; 
                        res.success.invoiceInfoList.forEach(v => {
                            v.value = v.title;
                        });
                        this.titlevalue = res.success.invoiceInfoList;   
                        if (!this.userCode) {
                            this.invoiceInfo = this.titlevalue.filter(v => v.isRecent === '')[0] || this.titlevalue[0] || {};   
                        }                    
                             
                    },
                    complete: () => {
                       
                    }
                });
            },
            getCode() {
                if (!this.userCode) {
                    if (!this.usernameRegular.test(this.userObj.userName || '')) {
                        this.$Message({msg: this.$t('message.errUserName')});             
                        return;
                    }
                }
                // 昵称正则验证
                if (!this.nicknameRegular.test(this.userObj.nickName) && this.userObj.nickName) {
                    this.$Message({msg: this.$t('message.errNickName')});
                    return;
                }
                if (!this.userCode) {
                    // 密码正则验证
                    if (!this.passwordRegular.test(this.userObj.password)) {
                        this.$Message({msg: this.$t('message.errPassword')});    
                        return;
                    }
                    // 密码输入一致验证
                    if (this.userObj.password !== this.iSpassword) {
                        this.$Message({msg: this.$t('message.a2ddlaan')}); 
                        return;
                    }
                }
                
                
                if (this.mainAccountPay.length === 0) {
                    this.$Message({msg: this.$t('message.b4wdqazl1n')});
                    return;
                } 
                let invoiceInfo = {};
                if (this.mainAccountPay[0] === '1') {
                    if (this.invoiceType.length === 0) {
                        this.$Message({msg: this.$t('message.b5sdbzdln')});
                        return;
                    } 
                    if (this.invoiceType[0] !== '0') {
                        if (['2','3'].includes(this.invoiceType[0]) && !this.invoiceInfo.financialMailbox) {
                            this.$Message({msg: this.$t('message.b4wdqazdn')});
                            return;
                        } 
                        if (['2','3'].includes(this.invoiceType[0]) && !this.emailReg.test(this.invoiceInfo.financialMailbox)) {
                            this.$Message({msg: this.$t('message.financialEmailEnterErr')});
                            return;
                        } 
                        if (!this.invoiceInfo.title) {
                            this.$Message({msg: this.$t('message.b5sdbaa')});
                            return;
                        } else if (!this.invoiceInfo.bankName) {
                            this.$Message({msg: this.$t('message.b4wdqaa')});
                            return;
                        } else if (!this.invoiceInfo.bankAccount) {
                            this.$Message({msg: this.$t('message.b2wdd1a')});
                            return;
                        } else if (!this.invoiceInfo.increaseTicketAddressPhone) {
                            this.$Message({msg: this.$t('message.b1dsk1a')});
                            return;
                        } else if (!this.invoiceInfo.taxId) {
                            this.$Message({msg: this.$t('message.a2ddlaa')});
                            return;
                        }
                        if (['2','3'].includes(this.invoiceType[0])) {
                            invoiceInfo = {
                                title: this.invoiceInfo.title,
                                bankName: this.invoiceInfo.bankName,
                                bankAccount: this.invoiceInfo.bankAccount,
                                increaseTicketAddressPhone: this.invoiceInfo.increaseTicketAddressPhone,
                                taxId: this.invoiceInfo.taxId
                            };
                        }
                    } 
                }
                if (!this.feeTemplateObj.feeTemplateId) {
                    this.$Message({msg: this.$t('message.b5sdbzddab')});
                    return;
                } 
 
                // 手机号验证
                if (!this.mobileRegular.test(this.userObj.mobile) && this.userObj.mobile) {
                    this.$Message({msg: this.$t('message.errMobile')});
                    return;
                }
                // 邮箱验证
                if (!this.emailReg.test(this.userObj.email) && this.userObj.email) {
                    this.$Message({msg: this.$t('message.errEmail')});
                    return;
                }
                let invoiceMerge = '';
                if (this.mainAccountPay[0] === '0') {
                    invoiceMerge = '';
                } else {
                    if (this.invoiceType[0] !== '2') {
                        invoiceMerge = '0';
                    } else {
                        invoiceMerge = this.invoiceMerge[0] || '0';
                    }
                }
                let userObj = {...this.userObj,mobile: this.userObj.mobile ? '+' + this.userObj.SMSCode + '-' + this.userObj.mobile : ''}; 
                if (this.userCode) {             
                    delete userObj.userName;
                }
                // 税号必须18位
                if (this.mainAccountPay[0] === '1' && invoiceInfo.taxId && invoiceInfo.taxId.length !== 18) {
                    this.$Alert({
                        msg: '纳税人识别号必须为18位'
                    });
                    return;
                }
                
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportAccountSubHandler.ashx',
                    data: {
                        act: !this.userCode ? 'postCreateImportSubAccountData' : 'postModifyImportSubAccountData',// 获取 进口订单状态节点的数据 
                        ...userObj, 
                        userCode: !this.userCode ? undefined : this.userCode,// 用户CODE
                        feeTemplateId: this.feeTemplateObj.feeTemplateId,// 费用模版Id
                        mainAccountPay: this.mainAccountPay[0],// 是否主账户支付 0-N、1-Y（当主账户支付时，需传开票参数）
                        invoiceType: this.mainAccountPay[0] === '0' ? '' : this.invoiceType[0],// 开票类型 0-DEBIT NOTE、2-增值税普通发票（电票）、3-增值税专用发票（纸票）
                        financialMailbox: (this.mainAccountPay[0] === '0' || this.invoiceType[0] === '0') ? '' : this.invoiceInfo.financialMailbox,// 财务邮箱
                        invoiceMerge: invoiceMerge,// 合并开票 1-合并开票、0-单独开票
                        invoiceInfo: JSON.stringify(invoiceInfo),// 开票信息 若不开票 发送空对象                 
                    },
                    beforeSend: () => {
                        this.loading = true;
                    },
                    success: () => {
                        this.$Alert({
                            msg: !this.userCode ? this.$t('message.a1wspaab') : this.$t('message.c6qdsadn'),
                            callback: () => {
                                this.$router.push({path: '/personalCenter/PersonalCenterMain/accountCenter/accountManagement/AccountManagement',query: {isImport: '1'}});
                            }
                        });   
                    },
                    complete: () => {
                        this.loading = false;
                    }
                });
            }
          
        }
    };
</script>
<style lang="scss" scoped>
    .CreatAccount {
        overflow: hidden;
        background-color: #f3f3f4;

        .container {
            position: relative;
            margin: 0 auto;

            /deep/ .el-input-group__append {
                color: #009fe8;
                background: #e7f6fd;
                border: 1px solid #009fe8;
            }

            .tit {
                color: #181818;

                .tcolor {
                    color: red;
                }
            }

            .titleBox:nth-of-type(1) {
                margin-top: 0;

                .tit {
                    height: auto;
                }
            }

            .titleBox {
                display: flex;
                margin-top: 15px;

                .tit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 50px;
                    color: #3d3a39;
                }
            }

            .siteNav {
                width: 1245px;
                margin: 0 auto;
            }

            .btn {
                color: #181818;
                background: #fff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 100%;
            }

            .input {
                width: 200px;
                height: 28px;

                /deep/ .el-input {
                    height: 100%;
                }
            }

            .info-item {
                display: flex;
                align-items: center;
                margin-top: 20px;
            }

            .info-item1:nth-of-type(1) {
                margin-top: 0;
            }

            .info-item1 {
                position: relative;
                margin-top: 10px;
                border: 1px solid #0aa7ee;
                border-radius: 4px;

                .tit {
                    display: flex;
                    align-items: center;
                    height: 35px;
                    padding: 0 20px;
                    font-size: 16px;
                    color: #181818;
                    background: #deeeff;

                    .tit1 {
                        margin-left: 12px;
                        color: #3d3a39;
                    }
                }

                .content {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    padding: 15px 20px;

                    .title {
                        color: #9b9b9b;
                    }

                    .unit {
                        margin-left: 32px;
                        color: #3d3a39;
                    }
                }
            }
        }

        /* 内容 */
        .contentBox1 {
            position: relative;
            min-height: 800px;
            background-color: #fff;

            .selectBox {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .text {
                    margin-right: 10px;
                    font-size: 18px;
                }
            }

            .topName {
                display: flex;

                .titleTwo {
                    width: 590px;
                    margin-left: 15px;
                    font-size: 20px;
                    font-weight: 500;
                    text-align: center;
                }

                .title {
                    width: 590px;
                    font-size: 20px;
                    font-weight: 500;
                    text-align: center;
                }
            }

            .separate {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                // 合同模板
                .displayTemplate {
                    position: relative;
                    box-sizing: border-box;
                    width: 590px;
                    height: 700px;
                    padding: 20px;
                    overflow-y: scroll;
                    box-shadow: -1px 0 8px 2px rgba(0, 0, 0, 0.21);

                    .capacityOne {
                        margin-top: 12px;
                        border: 1px solid #e8e8e8;

                        .tbody {
                            box-sizing: border-box;
                            display: flex;
                            width: 100%;
                            height: 44px;
                            padding: 12px 20px;
                            background-color: #deeeff;
                        }

                        .price {
                            box-sizing: border-box;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 100%;
                            padding: 15px 20px;
                        }

                        .priceEn {
                            flex-direction: column;
                            align-items: flex-start;
                        }
                    }

                    .capacityTwo {
                        position: relative;
                        margin-top: 12px;
                        border: 1px solid #e8e8e8;

                        .rightFeeName {
                            box-sizing: border-box;
                            padding: 12px 20px;
                            font-weight: bold;
                            background-color: #deeeff;
                            border-radius: 4px 4px 0 0;
                        }

                        .tbody {
                            padding: 15px 20px;
                            background-color: #deeeff;
                            border-radius: 4px 4px 0 0;

                            .feeName {
                                margin-left: 25px;
                                font-weight: bold;
                            }

                            .unit {
                                margin-left: 52px;
                            }
                        }

                        //  费用明细列表
                        .price {
                            box-sizing: border-box;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 15px 20px;
                            background-color: #fff;
                            border-radius: 0 0 4px 4px;

                            .unitPriceInput {
                                margin-left: 10px;
                            }
                        }

                        .priceEn {
                            flex-direction: column;
                            align-items: flex-start;
                        }

                        // 仓储费用明细列表
                        .content {
                            box-sizing: border-box;
                            background-color: #fff;
                            border-radius: 0 0 4px 4px;

                            .price {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;

                                .unitPriceInput {
                                    width: 100px;
                                    margin-left: 10px;
                                }
                            }

                            .priceEn {
                                flex-direction: column;
                                align-items: flex-start;
                            }

                            .safekeeping {
                                box-sizing: border-box;
                                display: flex;
                                align-items: center;
                                padding: 5px 35px;

                                .unitPriceInput {
                                    width: 100px;
                                    margin-left: 10px;
                                }
                            }
                        }

                        // 危险品仓储费用明细列表
                        .danger {
                            margin-bottom: 20px;
                            background-color: #fff;
                            border-radius: 0 0 4px 4px;

                            .dangerContent {
                                box-sizing: border-box;
                                display: flex;
                                align-items: center;
                                padding: 0 20px;

                                .cargoType {
                                    padding-bottom: 88px;
                                    padding-left: 0;
                                }

                                .price {
                                    display: flex;
                                    flex-direction: column;
                                    height: 135px;

                                    .tbodyp {
                                        width: 350px;

                                        .unitPriceInput {
                                            width: 100px;
                                            margin-right: 5px;
                                        }

                                        .dayInput {
                                            width: 55px;
                                            margin-right: 10px;
                                        }
                                    }
                                }

                                .priceEn {
                                    flex-direction: column;
                                    align-items: flex-start;
                                }
                            }

                            .minimumAmount {
                                box-sizing: border-box;
                                margin: 10px 0 10px 382px;
                            }

                            .unitPriceInput {
                                width: 100px;
                                margin-right: 5px;
                            }
                        }
                    }
                }

                .displayTemplate::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
            }

            .opeartingBtnBox {
                display: flex;
                justify-content: flex-end;
                margin-top: 30px;

                .opeartingBtn {
                    width: 120px;
                    height: 44px;
                    font-size: 20px;
                }
            }
        }
    }

</style>

